import request from '../request';
import { url } from '../service-utils';

/**
 * 解除密码锁定
 */
export async function unLock() {
  return request(`${url.salaryApi}/salary/initialize/managerUnlock`);
}

/**
 * 重置初始化设置
 */
export async function initialSettings() {
  return request(`${url.salaryApi}/salary/initialize/privacyInit`);
}
